export const formControlLabelStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  margin: 0,
};
